// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Layout-module--wrapper--Z-Fnr","disableBackground":"Layout-module--disableBackground--31FuY"};